module.exports = __webpack_public_path__ + "efd053e4c5af05f4d07f5f4daf9b5c77.png";